<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <div *ngIf="!isLoading; else shimmer">
        <div class="mb-16">
            <label>{{
                notificationPreviewRequestType === NotificationPreviewRequestType.REMOVE_DUE_DATE
                    ? ('GENERAL.MESSAGE.NOTIFICATION_PREVIEW_DESC_DUE_DATE_REMOVE' | translate)
                    : notificationPreviewRequestType === NotificationPreviewRequestType.REMINDER
                    ? notificationPreview.reminder_dates?.length
                        ? ('GENERAL.MESSAGE.NOTIFICATION_PREVIEW_DESC_DUE_DATE' | translate)
                        : ('GENERAL.MESSAGE.NOTIFICATION_PREVIEW_DESC_DUE_DATE_NO_REMINDER' | translate)
                    : ('GENERAL.MESSAGE.NOTIFICATION_PREVIEW_DESC' | translate)
            }}</label>
            <ul *ngIf="notificationPreview.reminder_dates?.length">
                <li *ngFor="let item of notificationPreview.reminder_dates">
                    {{ item | date: 'mediumDate' }}
                </li>
            </ul>
        </div>
        <div class="w-100-p p-16 bg-lightgreybackground rounded-s mb-8" *ngIf="notificationPreview.to_do; let todo">
            <label class="text-sm text-darktextcolor block mb-16">{{ 'GENERAL.PROPERTY.TODO' | translate }}</label>
            <div class="white p-16" fxLayout="column" fxLayoutAlign="space-between flex-start" [class.bg-red-100]="todo.is_overdue">
                <div class="w-100-p" fxLayoutAlign="space-between center">
                    <h4 class="mb-0 mt-0 mr-4 text-truncate font-medium" tabindex="0">
                        {{ todo.title }}
                    </h4>
                    <div class="new-badge" *ngIf="!todo.is_viewed_by_assignee">
                        <span>{{ 'GENERAL.NEW' | translate }}</span>
                    </div>
                    <div class="overdue-badge" *ngIf="todo.is_overdue && todo.is_viewed_by_assignee">
                        <span>{{ 'GENERAL.LABEL.OVERDUE' | translate }}</span>
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="center flex-start" class="w-full">
                    <span class="block">
                        {{
                            todo.type === ToDoTypeEnum.CERTIFICATE_TO_DO
                                ? todo.certificate_to_do.certificate?.module?.name
                                : todo.type === ToDoTypeEnum.MODULE_TO_DO
                                ? todo.module_to_do.module?.name
                                : todo.type === ToDoTypeEnum.SURVEY_TO_DO || todo.type === ToDoTypeEnum.QUIZ_TO_DO
                                ? todo.section_to_do.section.module?.name
                                : todo.type === ToDoTypeEnum.PERSONAL_REVIEW_TO_DO
                                ? todo.personal_review_to_do.personal_review?.name
                                : todo.type === ToDoTypeEnum.TEAM_REVIEW_TO_DO
                                ? todo.team_review_to_do.team_review?.name
                                : todo.type === ToDoTypeEnum.APPROVAL_REQUEST_TO_DO
                                ? todo.approval_request_to_do.approval_request?.course_name
                                : ''
                        }}
                    </span>
                    <span class="text-lightgreytextcolor block" [class.text-red-700]="todo.is_overdue"
                        >{{ 'GENERAL.PROPERTY.DUE_DATE' | translate }} {{ todo.due_date | date: 'shortDate' }}</span
                    >
                    <div fxLayout="row" fxLayoutAlign="flex-end" class="w-full">
                        <span class="text-gray-700 text-sm font-medium">{{ todo.type | getToDoAction: todo.module_to_do?.module.kind | translate }}</span>
                        <mat-icon>keyboard_arrow_right</mat-icon>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-100-p p-16 bg-lightgreybackground rounded-s mb-8" *ngIf="notificationPreview.feed_item; let item">
            <label class="text-sm text-darktextcolor block mb-16">{{ 'NAV.FEED.TITLE' | translate }}</label>
            <div class="feed-item-card pointer">
                <div class="feed-item-header w-100-p" fxLayoutAlign="space-between center">
                    <div fxLayoutAlign="flex-start center" fxLayoutGap="8px">
                        <div class="tag-wrapper" fxLayoutAlign="space-between center" fxLayoutGap="8px">
                            <img [src]="item.icon_url" alt="Feed item icon" />
                            <span>{{ item.header | translate }}</span>
                        </div>
                        <mat-icon class="urgent-icon" svgIcon="urgent" *ngIf="item.is_urgent"></mat-icon>
                    </div>
                    <div class="header-time">
                        {{ 'GENERAL.LABEL.NOW' | translate }}
                    </div>
                </div>
                <div class="feed-item-body w-100-p">
                    <div class="body-header pb-16" fxLayoutAlign="flex-start center">
                        <img class="avatar" [src]="item.image_url" [alt]="item.title" *ngIf="!item.is_personal; else userAvatar" />

                        <ng-template #userAvatar>
                            <div class="user-details-card-container">
                                <div class="relative" #avatarCell>
                                    <img class="avatar" *ngIf="item.image?.url; else initials" [src]="item.image_url" [alt]="item.title" />
                                    <ng-template #initials>
                                        <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ item.user.fullName | initials }}</div>
                                    </ng-template>
                                    <ng-template [onlineStateIndicator]="item.user.is_online"> </ng-template>
                                </div>
                                <app-user-details-card [user]="item.user" [target]="avatarCell" openedFrom="contact_card_feeditem"></app-user-details-card>
                            </div>
                        </ng-template>

                        <div fxLayout="column" fxLayoutAlign="center flex-start">
                            <span class="body-title" #title>{{ item.title }}</span>
                            <div class="user-details-card-container">
                                <app-user-details-card [user]="item.user" [target]="title" openedFrom="contact_card_feeditem" *ngIf="item.is_personal"></app-user-details-card>
                            </div>
                            <span class="body-subtitle">{{ item.subtitle }}</span>
                        </div>
                    </div>
                    <div class="tag-wrapper subject" *ngIf="item.subject">
                        <span>{{ item.subject }}</span>
                    </div>
                    <div class="body-message">
                        <span *ngIf="item.is_message_html; else translatableMessage" [innerHTML]="item.message | safeHtml"></span>
                        <ng-template #translatableMessage>
                            <span>{{ item.message | translate: translatableMessageProperties }}</span>
                        </ng-template>
                    </div>
                    <img class="extra-icon pt-24" [src]="item.extra_icon_url" [alt]="item.header" *ngIf="item.extra_icon_url" />
                </div>
            </div>
        </div>

        <div class="w-100-p p-16 bg-lightgreybackground rounded-s mb-8" *ngIf="notificationPreview.push_notification; let notification">
            <label class="text-sm text-darktextcolor block mb-16">{{ 'GENERAL.PROPERTY.PUSH_NOTIFICATION' | translate }}</label>
            <div class="p-24 white" fxLayoutAlign="flex-start center">
                <img [src]="logoSrc" alt="Logo" class="mr-16 max-w-[100px]" />
                <div fxLayout="column" fxLayoutAlign="center flex-start">
                    <h3 class="font-semibold mb-8 mt-0">{{ notification.title }}</h3>
                    <label>{{ notification.description }}</label>
                </div>
            </div>
        </div>

        <div class="w-100-p p-16 bg-lightgreybackground rounded-s" *ngIf="notificationPreview.email; let email">
            <label class="text-sm text-darktextcolor block mb-16">{{ 'GENERAL.PROPERTY.EMAIL' | translate }}</label>
            <div class="p-24 white" fxLayout="column" fxLayoutAlign="center flex-start">
                <p [innerHTML]="email"></p>
            </div>
        </div>
    </div>

    <ng-template #shimmer>
        <div class="shimmer-container p-0" fxLayout="column" fxLayoutAlign="space-between flex-start">
            <div class="shimmer w-100-p" fxLayout="column" fxLayoutAlign="center flex-start">
                <div class="shimmer-card module animate mt-8"></div>
                <div class="shimmer-card module animate mt-8"></div>
                <div class="shimmer-card module animate mt-8"></div>
            </div>
        </div>
    </ng-template>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayoutAlign="flex-end center" *ngIf="notificationPreviewRequestType === NotificationPreviewRequestType.REMOVE_DUE_DATE">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button [label]="'GENERAL.BUTTON.REMOVE_DUE_DATE'" [color]="'warn'" (onClick)="removeDueDate()"></app-flat-button>
</div>
